import color from 'color-js';

const red = color('#f62e5a');
const yellow = color('#FED130');
const cyan = color('#305dfe');
const green = color('#30fdcf');

const colors = {
    highlights: {
        red: {
            default: red.toString(),
            fontColor: '#fff',
            hover: red.darkenByAmount(0.1).toString(),
            light: red.lightenByAmount(0.35).toString(),
            dark: red.darkenByAmount(0.2).toString(),
        },
        yellow: {
            default: yellow.toString(),
            fontColor: yellow.darkenByAmount(0.5).toString(),
            hover: yellow.darkenByAmount(0.1).toString(),
            light: yellow.lightenByAmount(0.35).toString(),
            dark: yellow.darkenByAmount(0.2).toString(),
        },
        cyan: {
            default: cyan.toString(),
            fontColor: '#fff',
            hover: cyan.darkenByAmount(0.1).toString(),
            light: cyan.lightenByAmount(0.35).toString(),
            dark: cyan.darkenByAmount(0.2).toString(),
        },
        green: {
            default: green.toString(),
            fontColor: green.darkenByAmount(0.4).toString(),
            hover: green.darkenByAmount(0.1).toString(),
            light: green.lightenByAmount(0.35).toString(),
            dark: green.darkenByAmount(0.2).toString(),
        },
    },
};

const theme = {
    colors,
};

export default theme;



// WEBPACK FOOTER //
// ./src/components/theme.js